import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import looppa from 'looppa';
import Loader from 'components/loader';
import BoosterBarItem from './item';

class BoosterBar extends PureComponent {
    static propTypes = {
        notifications: PropTypes.array.isRequired,
        isFetching: PropTypes.bool.isRequired,
        remove: PropTypes.func.isRequired,
        isNative: PropTypes.bool.isRequired,
        isWrapped: PropTypes.bool,
        templateConfig: PropTypes.object.isRequired,
    };

    renderContent() {
        const { notifications, isFetching, remove } = this.props;
        return (
            <div className="booster-bar">
                {isFetching ? <Loader/> : (
                    <ul className="booster-bar--list u-reset">
                        {looppa(notifications)((notification, i) => (
                            <BoosterBarItem onRemove={() => remove({ notification })} key={i} {...notification} />
                        ))}
                    </ul>
                )}
            </div>
        );
    }

    render() {
        const { notifications, isFetching, isWrapped, isNative, templateConfig } = this.props;

        // no notifications :(
        if ((!isFetching && !notifications.length || isNative) || templateConfig.boosterbar === 'none') {
            return null;
        }

        if (isWrapped) {
            return (
                <div className="grid">
                    <div className="grid--container">
                        {this.renderContent()}
                    </div>
                </div>
            );
        }

        return this.renderContent();
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        notifications: 'notifications.items',
        isFetching: 'notifications.isFetching',
        isNative: 'viewport.isNative',
        templateConfig: 'router.config',
    }),
    reduxUtils.mapDispatchToProps({
        remove: 'notifications.remove',
    }),
)(BoosterBar);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/booster-bar/index.js